import isEqual from 'lodash/isEqual'
import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../../../constants/common'
import { getItemsIds } from '../../../../../utils/common'
import { formValidationSchemaNoChanged } from '../../../../Form'
import {
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION,
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS,
  REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT,
} from '../RequestProfileWidgetProviders.constants'

function isRequestProfileWidgetProvidersFormEqual({ initialValues, values }) {
  if (
    values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION]
  ) {
    return false
  }

  return isEqual(
    getItemsIds(
      values[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS] ??
        EMPTY_LIST,
      'value'
    ),
    getItemsIds(
      initialValues[REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS] ??
        EMPTY_LIST,
      'value'
    )
  )
}

export function getRequestProfileWidgetProvidersFormValidationSchema(
  initialValues
) {
  return Yup.object({
    [REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_IS_PROVIDERS_INVITATION]:
      Yup.boolean(),
    [REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS]: Yup.array().of(
      Yup.object()
    ),
    [REQUEST_PROFILE_WIDGET_PROVIDERS_FIELD_NAME_PROVIDERS_COMMENT]:
      Yup.string(),
  }).concat(
    formValidationSchemaNoChanged({
      initialValues,
      isEqual: isRequestProfileWidgetProvidersFormEqual,
    })
  )
}
